export enum APP_STATE {
  INITIALIZE = 'INITIALIZE',
  MAINTENANCE = 'MAINTENANCE',
  READY = 'READY',
}
